<template>
    <div class="footer fs14 index-footer">
        <div class="fl">
            <img :src="contact.wb_thumb" alt="" class="qr-img">
            <p class="tc">官方微博</p>
        </div>
        <div class="fr">
            <img :src="contact.wx_thumb" alt="" class="qr-img">
            <p class="tc">官方微信</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        contact:{
            type:Object,
            default:()=>{}
        }, 
    },
    data() {
        return {

        };
    }, 
    created(){
        
    }  
};
</script>

<style scoped lang="less">
    .footer{
        position:absolute;
        bottom:0;
        left:0;
        width:100%;
        height:152px;
        background:#1A3039;
        padding:20px 60px;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:20px;
        .qr-img{
            display: block;
            width:80px;
            height:80px;
            margin-bottom:8px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/IndexFooter.vue